import { Group, MockHook } from '@jupiterone/jupiter-web-toolkit';

const DEFAULT_INDEX = 0;
const ADD_MEMBER_INDEX = 1;
const PERMISSIONS_INDEX = 2;

export interface GroupListItemProps {
  onSelect: (id: Group['id'], tab: number) => void;
  item: Group;
}

const useGroupListItemLogic = ({ item, onSelect }: GroupListItemProps) => {
  const onAddMemberToGroup = () => onSelect(item.id, ADD_MEMBER_INDEX);
  const onClickSettings = () => onSelect(item.id, PERMISSIONS_INDEX);
  const onSelectItem = () => onSelect(item.id, DEFAULT_INDEX);

  return {
    onAddMemberToGroup,
    onClickSettings,
    onSelectItem,
    itemName: item.name,
  };
};

export type GroupListItemComponentProps = ReturnType<
  typeof useGroupListItemLogic
>;
export const MOCK_GROUP_LIST_ITEM_PROPS: GroupListItemComponentProps = {
  itemName: 'Group Name',
  onAddMemberToGroup: MockHook.mockFunction,
  onClickSettings: MockHook.mockFunction,
  onSelectItem: MockHook.mockFunction,
};

export default MockHook.useMockHook(
  useGroupListItemLogic,
  MOCK_GROUP_LIST_ITEM_PROPS
);
